import { Card, Heading, RadioCard, vars } from '@etg/wings';
import { css } from '@eti/styles';
import type { TicketProps } from '../../model';
import { PriceInfoLabel } from '../common/PriceInfoLabel';
import { TicketInformation } from './common/TicketInformation';

const getRadioCardStyles = (hasError: boolean) => css`
  background: transparent;
  height: 100%;
  ${hasError ? `border-color: ${vars.colors.signal.critical.foreground}` : ''};
`;

const headingStyles = css`
  font-size: 0.875rem;
`;

const cardSectionWrapperStyles = css`
  border: none;
  padding: 0 16px;
`;

const cardSectionStyles = css`
  padding: 16px 0;
`;

const cardSectionBottomStyles = css`
  padding: 16px 0 8px;
`;

const cardStyles = css`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TicketCardV3 = ({ hasError = false, ticket }: TicketProps) => {
  const { ticketTitle, ticketType } = ticket;
  return (
    <RadioCard
      className={getRadioCardStyles(hasError)}
      label={
        <Heading className={headingStyles} data-testid={`ticket-${ticketType}`} level={2}>
          {ticketTitle}
        </Heading>
      }
      value={ticketType}
    >
      <Card.Section className={cardSectionWrapperStyles}>
        <Card className={cardStyles}>
          <Card.Section className={cardSectionStyles}>
            <PriceInfoLabel isAtBottom={false} ticket={ticket} ticketVersion={3} />
          </Card.Section>
          <Card.Section className={cardSectionBottomStyles}>
            <TicketInformation ticketType={ticketType} ticketVersion={3} />
          </Card.Section>
        </Card>
      </Card.Section>
    </RadioCard>
  );
};
